
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","fill":"#FF8A8C"}}),_c('path',{attrs:{"d":"M11.964 15.273H9.5V8h2.514c.722 0 1.343.146 1.861.437.52.289.92.704 1.2 1.246.28.542.42 1.191.42 1.946 0 .758-.141 1.409-.423 1.953a2.92 2.92 0 01-1.211 1.254c-.526.291-1.158.437-1.897.437zm-1.146-1.14H11.9c.506 0 .929-.092 1.267-.277.339-.187.593-.465.764-.835.17-.371.255-.835.255-1.392 0-.556-.085-1.018-.255-1.385a1.743 1.743 0 00-.757-.827c-.331-.185-.743-.277-1.235-.277h-1.122v4.993z","fill":"#000"}})])
          )
        }
      }
    